import script from "./submit11.vue?vue&type=script&setup=true&lang=js"
export * from "./submit11.vue?vue&type=script&setup=true&lang=js"

import "./submit11.vue?vue&type=style&index=0&id=ede6df50&scoped=true&lang=css"

import exportComponent from "D:\\doc\\project\\lunwenzhinengtougaopingtaitest2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ede6df50"]])

export default __exports__